import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: { // Exercise num
    unit: 'Unit 10',
    id: 'SB3-U10-P72-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page72/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page72/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 10',
    id: 'SB3-U10-P72-E2',
    audio: 'img/FriendsPlus/Page72/Audio/audio-e2-p72.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page72/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page72/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page72/Audio/tieude-e2-p72.mp3' },
        { url: 'img/FriendsPlus/Page72/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page72/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: "Unit 10",
    id: "SB3-U10-P72-E3",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page72/E3/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#44509f", num: "3", title: 'Read again. Write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page72/E3/1.jpg" style="width: 100%">
            <div><b>1</b>&ensp;Who is Nga helping? She’s helping her <u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;mom&ensp;</u> and <u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;dad&ensp;</u>.</div>
            <div><b>2</b>&ensp;What is her aunt’s name? Her name’s #.</div>
            <div><b>3</b>&ensp;What color is Nga’s ao dai? It’s #.</div>
            <div><b>4</b>&ensp;What color are the invitations? They’re # and #.</div></div>
            <div><b>5</b>&ensp;What cake does Nga’s brother like? He likes the # cake.</div></div>
          </div>
        `,
        answer: ["Tam", "purple", "red", "yellow", "little"],
      },
    ],
  },
}

export default json;